var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 118,
    viewBox: "0 0 156 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10.2328 83.9802C1.88316 112.682 63.9379 109.14 90.7673 95.0763C118.635 80.4462 127.953 48.3433 126.377 18.4382C122.233 24.937 118.229 31.5351 113.482 37.7477C108.88 43.8295 99.3001 36.5875 104.051 30.6224C111.685 21.003 119.891 11.1233 126.386 0.74169L134.189 0.658146C142.324 9.37277 149.784 18.8134 155.351 29.4089L154.805 33.9532L152.732 35.5152L151.871 35.6916L147.644 34.0476C143.845 28.9326 139.822 24.0535 135.985 19.0161C142.643 54.3552 128.488 91.6721 94.1724 107.833C62.1098 122.996 -8.49693 122.761 -14.974 85.3532L-10.2328 83.9802Z",
    fill: "#FBA919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.7f838849a46acaa0702c3eb3b5ff58cf.svg";
export { ForwardRef as ReactComponent };